export const CalendarWeek = () => {
	return (
		<div class="week-view">
			<p>Week view coming soon...</p>
		</div>
	);
};
